import { createSlice } from '@reduxjs/toolkit';
import {
  fetchWorkspaceUsersList,
  bulkInviteWorkspaceUsers,
  fetchATtsWorkspaceUsersList,
} from './actions';

const initialState = {
  users: {
    workspaceUsers: [], // if no search term, this will get updated
    selectedUsers: [],
    searchedUsers: [], // if search term, this will get updated
  },
  seatLimitedDetails: {},
  isWorkspaceUsersLoading: false,
  isBulkInviteSubmitting: false,
  search: {
    term: null,
  },
};

const { reducer, actions } = createSlice({
  name: 'workspaceUsers',
  initialState,
  reducers: {
    applySearchTerm: (state, { payload }) => {
      state.search.term = payload?.searchTerm;
    },
    applySelectedUsers: (state, { payload }) => {
      if (!payload?.usersList) return;

      if (!state?.users?.selectedUsers?.length) {
        state.users.selectedUsers = payload?.usersList;
        return;
      }
      const combinedArray = state?.users?.selectedUsers.concat(
        payload?.usersList
      );

      state.users.selectedUsers = combinedArray.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t?.id === item?.id)
      );
    },
    removeSelectedUsers: (state, { payload }) => {
      if (
        !payload?.usersList ||
        !payload?.usersList?.length ||
        !state?.users?.selectedUsers?.length > 0
      )
        return;
      const temp = state?.users?.selectedUsers.filter((myObj) => {
        const foundUser = payload?.usersList?.find(
          (obj) => obj?.id === myObj?.id
        );
        return foundUser === undefined;
      });
      state.users.selectedUsers = temp;
    },
    applySelectedUser: (state, { payload }) => {
      if (!payload?.selectedUser?.id) return;
      const existingUser = state?.users?.selectedUsers?.find(
        (user) => user?.id === payload?.selectedUser?.id
      );
      if (!existingUser)
        state?.users?.selectedUsers?.push(payload?.selectedUser);
    },
    removeSelectedUser: (state, { payload }) => {
      if (!payload?.unSelectedUser?.id) return;
      state.users.selectedUsers = state?.users?.selectedUsers?.filter(
        (user) => user?.id !== payload?.unSelectedUser?.id
      );
    },
    updateUserRole: (state, { payload }) => {
      if (!payload?.user || !payload?.role) return;

      const selectedUserIndex = state?.users?.selectedUsers?.findIndex(
        (user) => user?.id === payload?.user
      );

      if (selectedUserIndex !== -1) {
        // Scoped roles (e.g. Department head / Site lead) carry a per-user
        // department/office scope alongside the role.
        state.users.selectedUsers[selectedUserIndex] = {
          ...state?.users?.selectedUsers[selectedUserIndex],
          role: payload?.role,
          scoped_department_ids: payload?.scoped_department_ids,
          scoped_office_ids: payload?.scoped_office_ids,
        };
      }
    },

    updateAllUsersRole: (state, action) => {
      const { role, scoped_department_ids, scoped_office_ids } = action.payload;
      state.users.selectedUsers = state?.users?.selectedUsers?.map((user) => ({
        ...user,
        role,
        // "Apply to all" copies the first user's scope too.
        scoped_department_ids,
        scoped_office_ids,
      }));
    },

    resetState: (state) => {
      state.users.workspaceUsers = [];
      state.users.selectedUsers = [];
      state.users.searchedUsers = [];
      state.search.term = null;
    },
  },

  extraReducers: {
    [fetchWorkspaceUsersList.pending]: (state) => {
      state.isWorkspaceUsersLoading = true;
    },

    [fetchWorkspaceUsersList.fulfilled]: (state, { payload }) => {
      // Temporary fix to hide slack users from workspace invite users
      if (state.search.term) {
        state.users.searchedUsers =
          payload?.data?.workspace_users?.filter(
            (u) => u?.ext_type !== 'slack'
          ) || [];
      } else {
        state.users.workspaceUsers =
          payload?.data?.workspace_users?.filter(
            (u) => u?.ext_type !== 'slack'
          ) || [];
        state.users.searchedUsers = [];
      }
      state.isWorkspaceUsersLoading = false;
    },

    //for ATS
    [fetchATtsWorkspaceUsersList.pending]: (state) => {
      state.isWorkspaceUsersLoading = true;
    },

    [fetchATtsWorkspaceUsersList.fulfilled]: (state, { payload }) => {
      if (state.search.term) {
        state.users.searchedUsers =
          payload?.data?.workspace_users?.filter(
            (u) => u?.ext_type !== 'slack'
          ) || [];
      } else {
        state.users.workspaceUsers =
          payload?.data?.workspace_users?.filter(
            (u) => u?.ext_type !== 'slack'
          ) || [];
        state.seatLimitedDetails = payload?.data?.seat_limit_details;
        state.users.searchedUsers = [];
      }
      state.isWorkspaceUsersLoading = false;
    },

    [bulkInviteWorkspaceUsers.pending]: (state) => {
      state.isBulkInviteSubmitting = true;
    },

    [bulkInviteWorkspaceUsers.fulfilled]: (state) => {
      state.isBulkInviteSubmitting = false;
    },
  },
});

export const {
  applySearchTerm,
  applySelectedUsers,
  removeSelectedUsers,
  applySelectedUser,
  removeSelectedUser,
  updateUserRole,
  updateAllUsersRole,
  resetState,
} = actions;
export default reducer;
